import { h, render } from 'vue';
import Dialog from './Dialog.vue';

const mount = (component, { props, children, element, app } = {}) => {
  let el = element ? element : document.createElement('div');
  let vNode = h(component, props, children);
  if (app && app._context) vNode.appContext = app._context;

  render(vNode, el);

  const destroy = () => {
    if (el) render(null, el);
    el = null;
    vNode = null;
  };

  return { vNode, destroy, el };
};

const instances = [];

const component = (options) => {
  // if (Vue.prototype.$isServer) return;

  const o = typeof options === 'string' ? { message: options } : options;
  const component = mount(Dialog, { props: { modelValue: true, type: 'alert', showTime: 0, ...o } });

  document.querySelector('body').appendChild(component.el);
  instances.push(component);
  /* eslint-disable */
  return component;
}
component.alert = function alert(title, message, options={}) {
  return component({ type: 'alert', title, message, ...options })
}
component.confirm = function confirm(title, options = {}) {
  return component({ type: 'confirm', showCancel: true, title, ...options })
}

component.clear = function clear() {
  instances.forEach((item) => {
    item.destroy()
  })
}

export default component
